import { endOfWeek, isWithinInterval, startOfWeek } from "date-fns";

import { RootState } from "..";
import { SliceStatus } from "../utils";
import { lecturesAdapter } from "./lecturesSlice";

export const selectLectureLoading = (state: RootState) =>
  state.lectures.status === SliceStatus.LOADING;

export const selectLectureState = (state: RootState) => state.lectures;

const { selectById, selectAll } =
  lecturesAdapter.getSelectors(selectLectureState);

export const selectAllLectures = selectAll;

export const selectLectureById = (id: number | string) => (state: RootState) =>
  selectById(state, Number(id));

export const selectAllLecturesThisWeek = (state: RootState) => {
  const lectures = selectAll(state);
  const today = new Date();


  const weekStart = startOfWeek(today, { weekStartsOn: 1 }); // Monday start
  const weekEnd = endOfWeek(today, { weekStartsOn: 1 });     // Sunday end

  // Filter lectures based on the date falling within this week
  return lectures.filter((lecture) => {
    const lectureDate = new Date(lecture.date); // Assuming the lecture date is a valid date string
    return isWithinInterval(lectureDate, { start: weekStart, end: weekEnd });
  });
};

export const selectLecturesAfterId = (id: number) => (state: RootState) => {
  const lectures = selectAll(state);
  return lectures.filter((lecture) => lecture.id > id);
};